import { defineMessages } from 'react-intl';

export default defineMessages({
    updateEmailandPhoneNo: {
        id: 'auth.components.ProfileUpdate.Update Email & Phone No.',
        defaultMessage: 'Update Email & Phone No.'
    },
    detailsUpdatedSuccess: {
        id: 'auth.components.ProfileUpdate.Details updated successfully!',
        defaultMessage: 'Details updated successfully!'
    },
    currentEmail: {
        id: 'auth.components.ProfileUpdate.Current Email (Username):',
        defaultMessage: 'Current Email (Username):'
    },
    newEmail: {
        id: 'auth.components.ProfileUpdate.New Email (Username):',
        defaultMessage: 'New Email (Username):'
    },
    currentPhoneNumber: {
        id: 'auth.components.phoneNumber.Current Phone Number:',
        defaultMessage: 'Current Phone Number:'
    },
    newPhoneNumber: {
        id: 'auth.components.phoneNumber.New Phone Number:',
        defaultMessage: 'New Phone Number:'
    },
    usernameHelperText: {
        id: 'auth.components.ProfileUpdate.username helper text',
        defaultMessage: 'Please note if you update your email address this becomes your new username when logging in.'
    },
    updateDetails: {
        id: 'auth.components.ProfileUpdate.Update Details',
        defaultMessage: 'Update Details'
    },
    errorEnterEmailPhone: {
        id: 'auth.components.ProfileUpdate.Error.errorEnterEmailPhone',
        defaultMessage: 'Please enter the new email/phone number to update'
    },
    errorEnterNewPhoneNumber: {
        id: 'auth.components.ProfileUpdate.Error.errorEnterNewPhoneNumber',
        defaultMessage: 'Your current phone number and new phone number are the same. Please enter a new phone number and try again.'
    },
    errorEnterNewEmailID: {
        id: 'auth.components.ProfileUpdate.Error.errorEnterNewEmailID',
        defaultMessage: 'Your old email ID and current email ID (username) are the same. Please enter a new email ID and try again.'
    },
    errorEnterValidEmailUpdate: {
        id: 'auth.components.ProfileUpdate.Error.errorEnterValidEmailUpdate',
        defaultMessage: 'Please enter a valid email to update'
    },
    errorEnterValidPhoneNoUpdate: {
        id: 'auth.components.ProfileUpdate.Error.errorEnterValidPhoneNoUpdate',
        defaultMessage: 'Please enter a valid phone number to update'
    },
   
	errorEmailAlreadyInUse: {
        id: 'auth.components.ProfileUpdate.Error.errorEmailAlreadyInUse',
        defaultMessage: 'The email you are trying to update is already in use.  Please update the information and try again.'
    },
    errorPhoneNoAlreadyInUse: {
        id: 'auth.components.ProfileUpdate.Error.errorPhoneNoAlreadyInUse',
        defaultMessage: 'The phone number you are trying to update is already in use.  Please update the information and try again.'
    },
    errorServerNonUpdation: {
        id: 'auth.components.ProfileUpdate.Error.errorServerNonUpdation',
        defaultMessage: 'Server Error, Not able to update'
    }


});
